import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AngularFirestore, DocumentChangeAction } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { Survey } from '../survey/survey.model';
import { AuthService } from '../../../../auth/auth.service';
import { TableState } from 'app/utils/table-state';

@Injectable()
export class SurveysService implements Resolve<any>
{
    surveys: any[];
    onSurveysChanged: BehaviorSubject<any>;

    // The state of the table
    tableState = new TableState();

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private http: HttpClient,
        private db: AngularFirestore,
        private authService: AuthService,
    )
    {
        // Set the defaults
        this.onSurveysChanged = new BehaviorSubject({});
    }

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {

        return new Promise((resolve, reject) => {

            Promise.all([
                this.getSurveys()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /**
     * Get surveys
     *
     * @returns {Promise<any>}
     */
    getSurveys(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            const productConfigId = this.authService.productConfigIdOfCurrentUser;
            console.log('getSurveys() productConfigId', productConfigId);
            this.db.collection<any>('surveys', ref => ref.where('productConfigId', '==', productConfigId).orderBy('startDate', 'desc')).snapshotChanges().pipe(
                map(actions => actions.map(a => {
                    const doc = a.payload.doc;
                    console.log('mappping survey with id', doc.id);
                    return Survey.parseFirebaseData(doc.id, doc.data());
                }))
            ).subscribe((response: any) => {
                console.log('got surveys:', response);
                this.surveys = response;
                this.onSurveysChanged.next(this.surveys);
                resolve(response);
            }, reject);
        });
    }
}
